import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/api';
import './Employees.css';
import GlobalHeader from './GlobalHeader';
import Snackbar from './Snackbar';
import BulkUploadResultPopup from './BulkUploadResultPopup';
import { config } from '../utils/config';

function Employees() {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiMessage, setApiMessage] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('All roles');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [totalCount, setTotalCount] = useState(0);
  const [currentCycleId, setCurrentCycleId] = useState(null);
  const [currentCycleName, setCurrentCycleName] = useState(null);
  const [assessmentStatuses, setAssessmentStatuses] = useState({});
  const [loadingStatuses, setLoadingStatuses] = useState(false);
  const [statusesInitialized, setStatusesInitialized] = useState(false);
  const [statusFilter, setStatusFilter] = useState('All');
  const [departmentFilter, setDepartmentFilter] = useState('All');
  
  // Role change modal states
  const [roleChangeModalOpen, setRoleChangeModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [availableRolesForDept, setAvailableRolesForDept] = useState([]);
  const [selectedNewRole, setSelectedNewRole] = useState('');
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [updatingRole, setUpdatingRole] = useState(false);
  const [snackbar, setSnackbar] = useState({ message: '', type: 'success', isOpen: false });
  const [roleSearchTerm, setRoleSearchTerm] = useState('');
  
  // Bulk upload states
  const [bulkUploading, setBulkUploading] = useState(false);
  const [bulkUploadResult, setBulkUploadResult] = useState(null);
  const [showBulkUploadResult, setShowBulkUploadResult] = useState(false);
  
  // Notify states
  const [notifyModalOpen, setNotifyModalOpen] = useState(false);
  const [selectedEmployeesForNotify, setSelectedEmployeesForNotify] = useState([]);
  const [sendingNotifications, setSendingNotifications] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  // Set page title
  useEffect(() => {
    document.title = 'CR Capability Index - Employees';
  }, []);

  // Fetch current cycle from /ci/cycle API
  useEffect(() => {
    const fetchCurrentCycle = async () => {
      try {
        const response = await apiService.fetchData('ci/cycle');
        if (response && response.status === 'success' && response.cycle) {
          const cycleId = response.cycle.CycleID;
          const cycleName = response.cycle.Name;
          console.log('Current cycle fetched:', { cycleId, cycleName });
          setCurrentCycleId(cycleId);
          setCurrentCycleName(cycleName);
        } else {
          console.log('No cycle found in response:', response);
        }
      } catch (err) {
        console.error('Error fetching current cycle:', err);
      }
    };
    fetchCurrentCycle();
  }, []);

  const handleEmployeesResponse = (
  response,
  setEmployees,
  setTotalCount,
  setApiMessage,
  setError
) => {
  if (!response) {
    setEmployees([]);
    setTotalCount(0);
    setApiMessage(null);
    return;
  }

  if (response.status === 'not_found' && response.message) {
    setApiMessage(response.message);
    setError(null);
    setEmployees([]);
    setTotalCount(0);
    return;
  }

  if (Array.isArray(response.employees)) {
    setEmployees(response.employees);
    setTotalCount(response.count || response.employees.length);

    if (response.employees.length === 0) {
      setApiMessage(
        response.message || 'No employees found under your supervision.'
      );
      setError(null);
    } else {
      setApiMessage(null);
    }
    return;
  }

  if (response.message) {
    setApiMessage(response.message);
    setError(null);
    setEmployees([]);
    setTotalCount(0);
    return;
  }

  setEmployees([]);
  setTotalCount(0);
  setApiMessage(null);
};

  // Fetch employees data from API
  // useEffect(() => {
  //   const fetchEmployees = async () => {
  //     try {
  //       setLoading(true);
  //       setError(null);
  //       setApiMessage(null);
        
  //       // Get logged-in user email from sessionStorage
  //       const userEmail = sessionStorage.getItem('user_emailId');
  //       if (!userEmail) {
  //         throw new Error('User email not found in session storage');
  //       }

  //       // Encode email for URL (in case it has special characters)
  //       const encodedEmail = encodeURIComponent(userEmail);
        
  //       // Build API URL with cycle_id if available
  //       let apiUrl = `ci/employees_under/${encodedEmail}`;
  //       if (currentCycleId) {
  //         apiUrl += `?cycle_id=${currentCycleId}`;
  //       }
        
  //       // Call API
  //       const response = await apiService.fetchData(apiUrl);
        
  //       if (response) {
  //         // Check if response has status "not_found" - this means no employees found
  //         if (response.status === 'not_found' && response.message) {
  //           setApiMessage(response.message);
  //           setError(null);
  //           setEmployees([]);
  //           setTotalCount(0);
  //         }
  //         // Check if response has employees array
  //         else if (response.employees && Array.isArray(response.employees)) {
  //           setEmployees(response.employees);
  //           setTotalCount(response.count || response.employees.length);
  //           // If employees array is empty and there's a message, display the message
  //           if (response.employees.length === 0 && response.message) {
  //             setApiMessage(response.message);
  //             setError(null);
  //           } else if (response.employees.length === 0) {
  //             setEmployees([]);
  //             setTotalCount(0);
  //             setApiMessage('No employees found under your supervision.');
  //           } else {
  //             setApiMessage(null);
  //           }
  //         } else if (response.message) {
  //           // If there's a message but no employees array, display the message
  //           setApiMessage(response.message);
  //           setError(null);
  //           setEmployees([]);
  //           setTotalCount(0);
  //         } else {
  //           // Invalid response format
  //           setEmployees([]);
  //           setTotalCount(0);
  //           setApiMessage(null);
  //         }
  //       } else {
  //         setEmployees([]);
  //         setTotalCount(0);
  //         setApiMessage(null);
  //       }
  //     } catch (err) {
  //       console.error('Error fetching employees:', err);

  //       // Show error message for any API errors
  //       const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch employees data';
  //       setError(errorMessage);
  //       setApiMessage(null);
  //       setEmployees([]);
  //       setTotalCount(0);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchEmployees();
  // }, [currentCycleId]);
  useEffect(() => {
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      setError(null);
      setApiMessage(null);

      const userEmail = sessionStorage.getItem('user_emailId');
      if (!userEmail) {
        throw new Error('User email not found in session storage');
      }

      const encodedEmail = encodeURIComponent(userEmail);
      const apiUrl = currentCycleId
        ? `ci/employees_under/${encodedEmail}?cycle_id=${currentCycleId}`
        : `ci/employees_under/${encodedEmail}`;

      const response = await apiService.fetchData(apiUrl);

      handleEmployeesResponse(
        response,
        setEmployees,
        setTotalCount,
        setApiMessage,
        setError
      );
    } catch (err) {
      console.error('Error fetching employees:', err);
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to fetch employees data';

      setError(errorMessage);
      setApiMessage(null);
      setEmployees([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  fetchEmployees();
}, [currentCycleId]);


  // Fetch assessment statuses for all employees
  useEffect(() => {
    const fetchAssessmentStatuses = async () => {
      const userEmail = sessionStorage.getItem('user_emailId');

      if (!currentCycleId) {
        console.log('Skipping assessment status fetch: No cycle ID');
        return;
      }

      if (!userEmail) {
        console.log('Skipping assessment status fetch: No user email');
        return;
      }

      if (!employees || employees.length === 0) {
        console.log('Skipping assessment status fetch: No employees loaded yet');
        return;
      }

      setStatusesInitialized(true);
      try {
        setLoadingStatuses(true);

        // Fetch manager assessment status
        const apiUrl = `assessment-status?cycle_id=${currentCycleId}&manager=${userEmail}`;
        console.log('Fetching assessment statuses:', apiUrl);
        
        const statusResponse = await apiService.fetchData(apiUrl);
        console.log('Assessment status response:', statusResponse);
        
        if (statusResponse) {
          setAssessmentStatuses(statusResponse);
        }
      } catch (err) {
        console.error('Error fetching assessment statuses:', err);
      } finally {
        setLoadingStatuses(false);
      }
    };

    fetchAssessmentStatuses();
  }, [currentCycleId, employees]);

  // Get unique roles for dropdown
  const uniqueRoles = ['All roles', ...new Set(employees.map(emp => emp.Role).filter(Boolean))];

  // Get unique departments for dropdown
  const uniqueDepartments = ['All', ...new Set(employees.map(emp => emp.DepartmentName).filter(Boolean))];

  // Get assessment status for an employee
  const getEmployeeAssessmentStatus = (employeeEmail) => {
    // If response is empty {}, all employees should show "Not Submitted"
    if (!assessmentStatuses || Object.keys(assessmentStatuses).length === 0) {
      return { status: 'locked', text: '🔒 Not Submitted', icon: '🔒' };
    }

    // Check if employee email exists in the response
    const employeeEmailExists = employeeEmail in assessmentStatuses;

    if (!employeeEmailExists) {
      // Employee not in response - show Not Submitted
      return { status: 'locked', text: '🔒 Not Submitted', icon: '🔒' };
    }

    // Check the value for this employee's email
    const assessmentValue = assessmentStatuses[employeeEmail];

    if (assessmentValue === true) {
      // Value is true - show View Assessment
      return { status: 'view', text: '👁️ View Assessment', icon: '👁️' };
    } else {
      // Value is false - show Take Assessment
      return { status: 'submit', text: 'Take Assessment', icon: '📝' };
    }
  };

  // Sorting function
  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  // Sort employees
  const sortedEmployees = [...employees].sort((a, b) => {
    if (!sortColumn) return 0;

    let aValue = a[sortColumn];
    let bValue = b[sortColumn];

    // Handle null/undefined values
    if (aValue == null) aValue = '';
    if (bValue == null) bValue = '';

    // Convert to string for comparison
    aValue = String(aValue).toLowerCase();
    bValue = String(bValue).toLowerCase();

    if (sortDirection === 'asc') {
      return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
    } else {
      return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
    }
  });

  // Filter employees based on search, role filter, status filter, and department filter
  const filteredEmployees = sortedEmployees.filter(employee => {
    const matchesSearch = 
      (employee.FullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (employee.Email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (employee.DepartmentName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (employee.Role || '').toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesRole = roleFilter === 'All roles' || employee.Role === roleFilter;
    
    const matchesDepartment = departmentFilter === 'All' || employee.DepartmentName === departmentFilter;
    
    // Status filter logic
    let matchesStatus = true;
    if (statusFilter !== 'All') {
      const statusInfo = getEmployeeAssessmentStatus(employee.Email);
      if (statusFilter === 'Not Submitted') {
        matchesStatus = statusInfo.status === 'locked';
      } else if (statusFilter === 'Submitted') {
        matchesStatus = statusInfo.status === 'submit';
      } else if (statusFilter === 'Completed') {
        matchesStatus = statusInfo.status === 'view';
      }
    }
    
    return matchesSearch && matchesRole && matchesDepartment && matchesStatus;
  });

  // Pagination
  const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedEmployees = filteredEmployees.slice(startIndex, endIndex);

  // Update current page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, roleFilter, statusFilter, departmentFilter]);

  // Handle Take Assessment button click
  const handleTakeAssessment = (employee) => {
    console.log('Take Assessment for:', employee);
    // Navigate to take assessment page with employee data
    navigate('/takeassessment', {
      state: {
        employeeEmail: employee.Email,
        employeeName: employee.FullName,
        employeeDepartment: employee.DepartmentName,
        employeeRole: employee.Role,
        employeeId: employee.ID,
        cycleId: currentCycleId // Include current cycle ID
      }
    });
  };

  // Get sort icon
  const getSortIcon = (column) => {
    if (sortColumn !== column) {
      return '↕️';
    }
    return sortDirection === 'asc' ? '↑' : '↓';
  };

  // Handle Take Self Assessment button click
  const handleTakeSelfAssessment = () => {
    const userName = sessionStorage.getItem('user_name');
    const userEmail = sessionStorage.getItem('user_emailId');

    navigate('/takeassessment', {
      state: {
        isManagerSelfAssessment: true, // Flag to indicate manager self-assessment
        employeeName: userName,
        employeeEmail: userEmail,
        employeeDepartment: sessionStorage.getItem('user_department'),
        employeeRole: sessionStorage.getItem('job_title')
      }
    });
  };

  // Fetch available roles for a department
  const fetchRolesForDepartment = async (departmentName) => {
    setLoadingRoles(true);
    try {
      // First get department ID from department name
      const deptResponse = await apiService.fetchData('metadata?type=departments');
      if (deptResponse?.status === 'success' && Array.isArray(deptResponse.data)) {
        const dept = deptResponse.data.find(d => d.DepartmentName === departmentName);
        if (dept) {
          // Fetch roles for this department
          const rolesResponse = await apiService.fetchData(`metadata?type=roles&department_id=${dept.DepartmentID}`);
          if (rolesResponse?.status === 'success' && Array.isArray(rolesResponse.data)) {
            setAvailableRolesForDept(rolesResponse.data);
          } else {
            setAvailableRolesForDept([]);
          }
        } else {
          setAvailableRolesForDept([]);
        }
      }
    } catch (err) {
      console.error('Failed to fetch roles for department:', err);
      setAvailableRolesForDept([]);
    } finally {
      setLoadingRoles(false);
    }
  };

  // Open role change modal
  const handleOpenRoleChangeModal = async (employee) => {
    setSelectedEmployee(employee);
    setSelectedNewRole(employee.Role || '');
    setRoleSearchTerm('');
    setRoleChangeModalOpen(true);
    await fetchRolesForDepartment(employee.DepartmentName);
  };

  // Close role change modal
  const handleCloseRoleChangeModal = () => {
    setRoleChangeModalOpen(false);
    setSelectedEmployee(null);
    setSelectedNewRole('');
    setAvailableRolesForDept([]);
    setRoleSearchTerm('');
  };

  // Update employee role
  const handleUpdateRole = async () => {
    if (!selectedEmployee || !selectedNewRole) {
      setSnackbar({ message: 'Please select a role', type: 'error', isOpen: true });
      return;
    }

    if (selectedNewRole === selectedEmployee.Role) {
      setSnackbar({ message: 'Please select a different role', type: 'warning', isOpen: true });
      return;
    }

    setUpdatingRole(true);
    try {
      const response = await apiService.putData(
        `employees?user_email=${encodeURIComponent(selectedEmployee.Email)}&role_name=${encodeURIComponent(selectedNewRole)}`
      );

      if (response?.status === 'success') {
        // Update the employee in local state
        setEmployees(prevEmployees =>
          prevEmployees.map(emp =>
            emp.Email === selectedEmployee.Email
              ? { ...emp, Role: selectedNewRole }
              : emp
          )
        );

        setSnackbar({
          message: `Role updated successfully for ${selectedEmployee.FullName}`,
          type: 'success',
          isOpen: true
        });
        handleCloseRoleChangeModal();
      } else {
        throw new Error(response?.message || 'Failed to update role');
      }
    } catch (err) {
      console.error('Failed to update role:', err);
      setSnackbar({
        message: err.message || 'Failed to update role',
        type: 'error',
        isOpen: true
      });
    } finally {
      setUpdatingRole(false);
    }
  };

  // Download template function
  const downloadTemplate = async () => {
    try {
      const userRole = sessionStorage.getItem('access_role') || '';
      const userDepartment = sessionStorage.getItem('user_department');
      const userEmail = sessionStorage.getItem('user_emailId');
      
      let apiUrl = '';
      if (userRole.toLowerCase() === 'admin') {
        apiUrl = 'employees/download-template'; // All departments
      } else {
        // For managers, pass their email to get employees under them
        apiUrl = `employees/download-template?department=${encodeURIComponent(userDepartment)}&manager_email=${encodeURIComponent(userEmail)}`;
      }
      
      const response = await apiService.fetchData(apiUrl, {
        responseType: 'blob'
      });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'employee_roles_template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setSnackbar({
        message: 'Template downloaded successfully!',
        type: 'success',
        isOpen: true
      });
    } catch (error) {
      console.error('Error downloading template:', error);
      setSnackbar({
        message: 'Failed to download template. Please try again.',
        type: 'error',
        isOpen: true
      });
    }
  };

  // Handle bulk upload
  const handleBulkUpload = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      
      try {
        setBulkUploading(true);
        setSnackbar({
          message: 'Uploading employee roles... Please wait.',
          type: 'info',
          isOpen: true,
          duration: 1200000 // 20 minutes
        });

        const formData = new FormData();
        formData.append('file', file);

        const response = await apiService.postData('employees/bulk-update-roles', formData);
        
        setBulkUploadResult(response);
        setShowBulkUploadResult(true);
        
        // Close the uploading snackbar
        setSnackbar({ message: '', type: 'success', isOpen: false });
        
        // Refresh employees list after successful upload
        window.location.reload();
        
      } catch (error) {
        console.error('Error uploading file:', error);
        const errorMessage = error.response?.data?.message || 'Failed to upload file. Please try again.';
        setSnackbar({
          message: errorMessage,
          type: 'error',
          isOpen: true
        });
      } finally {
        setBulkUploading(false);
      }
    };
    input.click();
  };

  // Get employees who haven't submitted assessment
  const notSubmittedEmployees = employees.filter(emp => {
    const statusInfo = getEmployeeAssessmentStatus(emp.Email);
    return statusInfo.status === 'locked';
  });

  // Handle notify modal
  const handleOpenNotifyModal = () => {
    setSelectedEmployeesForNotify([]);
    setSelectAll(false);
    setNotifyModalOpen(true);
  };

  const handleCloseNotifyModal = () => {
    setNotifyModalOpen(false);
    setSelectedEmployeesForNotify([]);
    setSelectAll(false);
  };

  const handleSelectAllToggle = () => {
    if (selectAll) {
      setSelectedEmployeesForNotify([]);
    } else {
      setSelectedEmployeesForNotify(notSubmittedEmployees.map(emp => emp.Email));
    }
    setSelectAll(!selectAll);
  };

  const handleEmployeeSelectToggle = (employeeEmail) => {
    if (selectedEmployeesForNotify.includes(employeeEmail)) {
      setSelectedEmployeesForNotify(prev => prev.filter(email => email !== employeeEmail));
    } else {
      setSelectedEmployeesForNotify(prev => [...prev, employeeEmail]);
    }
  };

  const sendNotificationEmails = async () => {
    if (selectedEmployeesForNotify.length === 0) {
      setSnackbar({ message: 'Please select at least one employee', type: 'warning', isOpen: true });
      return;
    }

    setSendingNotifications(true);
    try {
      const emailServiceUrl = "https://crticketingsystem-backend-dev.icyfield-14eece6f.eastus.azurecontainerapps.io/api/send_email";
      
      const selectedEmployeeDetails = employees.filter(emp => 
        selectedEmployeesForNotify.includes(emp.Email)
      );

      const emailPromises = selectedEmployeeDetails.map(async (employee) => {
        const emailData = {
          to: employee.Email,
          subject: `Reminder: Complete Your Self-Assessment - ${currentCycleName || 'Current Cycle'}`,
          html: `
            <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f9f9f9;">
              <div style="background-color: white; padding: 30px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                <div style="text-align: center; margin-bottom: 30px;">
                  <h1 style="color: #2563eb; margin: 0; font-size: 24px;">Assessment Reminder</h1>
                </div>
                
                <p style="color: #374151; font-size: 16px; line-height: 1.6; margin-bottom: 20px;">Dear ${employee.FullName},</p>
                
                <p style="color: #374151; font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                  This is a friendly reminder that your self-assessment for <strong>${currentCycleName || 'the current assessment cycle'}</strong> is still pending completion.
                </p>
                
                <div style="background-color: #f3f4f6; padding: 20px; border-radius: 6px; margin: 20px 0;">
                  <h3 style="color: #1f2937; margin: 0 0 10px 0; font-size: 18px;">Assessment Details:</h3>
                  <p style="margin: 5px 0; color: #4b5563;"><strong>Employee:</strong> ${employee.FullName}</p>
                  <p style="margin: 5px 0; color: #4b5563;"><strong>Department:</strong> ${employee.DepartmentName}</p>
                  <p style="margin: 5px 0; color: #4b5563;"><strong>Role:</strong> ${employee.Role}</p>
                  <p style="margin: 5px 0; color: #4b5563;"><strong>Assessment Cycle:</strong> ${currentCycleName || 'Current Cycle'}</p>
                </div>
                
                <p style="color: #374151; font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                  Please log in to the Capability Index system to complete your self-assessment at your earliest convenience.
                </p>
                
                <div style="text-align: center; margin: 30px 0;">
                  <a href="${config.frontendUrl}/login" style="background-color: #2563eb; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">Complete Assessment</a>
                </div>
                
                <p style="color: #6b7280; font-size: 14px; line-height: 1.6; margin-top: 30px; border-top: 1px solid #e5e7eb; padding-top: 20px;">
                  If you have any questions or need assistance, please contact your manager or the HR team.
                </p>
                
                <p style="color: #6b7280; font-size: 14px; margin-top: 20px;">
                  Best regards,<br>
                  <strong>BTG Team</strong>
                </p>
              </div>
            </div>
          `
        };

        const response = await fetch(emailServiceUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(emailData)
        });

        if (!response.ok) {
          throw new Error(`Failed to send email to ${employee.Email}`);
        }

        return { email: employee.Email, success: true };
      });

      const results = await Promise.allSettled(emailPromises);
      const successful = results.filter(result => result.status === 'fulfilled').length;
      const failed = results.filter(result => result.status === 'rejected').length;

      if (successful > 0) {
        setSnackbar({
          message: `Notifications sent successfully to ${successful} employee${successful > 1 ? 's' : ''}${failed > 0 ? `. ${failed} failed.` : ''}`,
          type: successful === selectedEmployeesForNotify.length ? 'success' : 'warning',
          isOpen: true
        });
      } else {
        setSnackbar({
          message: 'Failed to send notifications. Please try again.',
          type: 'error',
          isOpen: true
        });
      }

      handleCloseNotifyModal();
    } catch (error) {
      console.error('Error sending notifications:', error);
      setSnackbar({
        message: 'Failed to send notifications. Please try again.',
        type: 'error',
        isOpen: true
      });
    } finally {
      setSendingNotifications(false);
    }
  };

  // Calculate results count
  const resultsStart = filteredEmployees.length > 0 ? startIndex + 1 : 0;
  const resultsEnd = Math.min(endIndex, filteredEmployees.length);

  return (
    <div className="employees-container">
      <GlobalHeader />
      {/* Header */}
      <div className="ma-page-header">
        <button className="ma-back-button" onClick={() => navigate('/Home')}>
          <span className="back-icon">←</span> Back to Home
        </button>

        <div className="ma-header-content">
          <div className="ma-heading">
            <h1 className="page-title">Employees</h1>
            <p className="page-subtitle">
              View and manage employee information for assessments.
            </p>
            {currentCycleName && (
              <div style={{ marginTop: '8px' }}>
                <span className="cycle-name-badge">Assessment Cycle: {currentCycleName}</span>
              </div>
            )}
          </div>
          <div className="ma-ca-button">
            <button
              className="create-assessment-btn"
              onClick={handleTakeSelfAssessment}
            >
               Take Self Assessment
            </button>
            
            <button 
              className="download-template-btn"
              onClick={downloadTemplate}
            >
              📥 Download Template
            </button>
            
            <button 
              className="bulk-upload-btn"
              onClick={handleBulkUpload}
              disabled={bulkUploading}
            >
              {bulkUploading ? '⏳ Uploading...' : '📤 Bulk Upload'}
            </button>
            
            <button 
              className="notify-btn"
              onClick={handleOpenNotifyModal}
              disabled={employees.length === 0}
            >
              📧 Notify
            </button>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="controls-section">
        <div className="search-container">
          <div className="search-input">
            <input
              type="text"
              placeholder="Search by name, email, department, or role..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        
        <div className="filter-container">
          <div className="results-count">
            Results {filteredEmployees.length}
          </div>
          
          <select
            value={departmentFilter}
            onChange={(e) => setDepartmentFilter(e.target.value)}
            className="status-filter"
            style={{ marginLeft: '8px' }}
          >
            {uniqueDepartments.map(dept => {
              const deptCount = dept === 'All' ? employees.length : 
                employees.filter(emp => emp.DepartmentName === dept).length;
              return (
                <option key={dept} value={dept}>
                  {dept === 'All' ? 'All Departments' : dept} ({deptCount})
                </option>
              );
            })}
          </select>
          
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="status-filter"
          >
            <option value="All">All</option>
            <option value="Not Submitted">Not Submitted</option>
            <option value="Submitted">Submitted (Take Assessment)</option>
            <option value="Completed">Completed Manager Assessment (View Assessment)</option>
          </select>

          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            className="filter-dropdown"
            style={{ marginLeft: '8px' }}
          >
            {uniqueRoles.map(role => {
              const resourceCount = role === 'All roles' ? employees.length : 
                employees.filter(emp => emp.Role === role).length;
              return (
                <option key={role} value={role}>
                  {role} ({resourceCount})
                </option>
              );
            })}
          </select>
        </div>
      </div>

      {/* Loading State */}
      {(loading || loadingStatuses) && (
        <div className="loading-container">
          <p>{loading ? 'Loading employees...' : 'Loading assessment status...'}</p>
        </div>
      )}

      {/* Error State */}
      {error && !loading && !loadingStatuses && (
        <div className="error-container">
          <p>{error}</p>
        </div>
      )}

      {/* API Message State */}
      {apiMessage && !loading && !loadingStatuses && !error && (
        <div className="api-message-container">
          <p>{apiMessage}</p>
        </div>
      )}

      {/* Employee Table */}
      {!loading && !loadingStatuses && !error && !apiMessage && statusesInitialized && employees.length > 0 && (
        <>
          <div className="table-container">
            <table className="employees-table">
              <thead>
                <tr>
                  <th>
                    Sno
                  </th>
                  <th onClick={() => handleSort('FullName')} className="sortable-header">
                    Full Name {getSortIcon('FullName')}
                  </th>
                  <th onClick={() => handleSort('Email')} className="sortable-header">
                    Email {getSortIcon('Email')}
                  </th>
                  <th onClick={() => handleSort('DepartmentName')} className="sortable-header">
                    Department {getSortIcon('DepartmentName')}
                  </th>
                  <th onClick={() => handleSort('Role')} className="sortable-header">
                    Role {getSortIcon('Role')}
                  </th>
                  <th>Change Role</th>
                  <th>Review</th>
                </tr>
              </thead>
              <tbody>
                {paginatedEmployees.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="no-data">
                      No employees found
                    </td>
                  </tr>
                ) : (
                  paginatedEmployees.map((employee, index) => (
                    <tr key={employee.ID || index}>
                      <td>{startIndex + index + 1}</td>
                      <td>{employee.FullName || 'N/A'}</td>
                      <td>{employee.Email || 'N/A'}</td>
                      <td>{employee.DepartmentName || 'N/A'}</td>
                      <td>{employee.Role || 'N/A'}</td>
                      <td style={{ textAlign: 'center' }}>
                        {(() => {
                          const statusInfo = getEmployeeAssessmentStatus(employee.Email);
                          const isEmployeeSubmitted = statusInfo.status === 'submit' || statusInfo.status === 'view';
                          
                          return (
                            <button
                              className={`edit-role-btn ${isEmployeeSubmitted ? 'disabled' : ''}`}
                              onClick={() => !isEmployeeSubmitted && handleOpenRoleChangeModal(employee)}
                              title={isEmployeeSubmitted ? 'Cannot change role after employee has submitted assessment' : 'Change Role'}
                              disabled={isEmployeeSubmitted}
                            >
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5l3 3L12 15l-4 1 1-4 9.5-9.5z" />
                              </svg>
                            </button>
                          );
                        })()}
                      </td>
                      <td>
                        {(() => {
                          const statusInfo = getEmployeeAssessmentStatus(employee.Email);
                          return (
                            <button
                              className={`take-assessment-btn ${statusInfo.status === 'locked' ? 'locked' : ''} ${statusInfo.status === 'view' ? 'view-mode' : ''}`}
                              onClick={() => handleTakeAssessment(employee)}
                              disabled={statusInfo.status === 'locked'}
                              title={statusInfo.status === 'locked' ? 'Employee has not submitted self-assessment' : ''}
                            >
                              {statusInfo.status === 'locked' ? '🔒 Not Submitted' :
                               statusInfo.status === 'view' ? '👁️ View Assessment' :
                               statusInfo.status === 'submit' ? 'Review Assessment' : statusInfo.text}
                            </button>
                          );
                        })()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filteredEmployees.length > 0 && (
            <div className="pagination-section">
              <div className="pagination-info">
                Showing {resultsStart} to {resultsEnd} of {filteredEmployees.length} entries
                {/* <span style={{ marginLeft: '16px', marginRight: '8px' }}>Rows per page:</span>
                <select
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '4px 8px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '14px',
                    marginLeft: '4px'
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select> */}
              </div>

              {totalPages > 1 && (
                <div className="pagination-controls">
                   <span style={{ marginLeft: '16px', marginRight: '8px' }}>Rows per page:</span>
                <select
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '4px 8px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '14px',
                    marginLeft: '4px'
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                  <button
                    className="pagination-btn"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Previous
                  </button>

                  <div className="page-numbers">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
                      // Show first page, last page, current page, and pages around current
                      if (
                        page === 1 ||
                        page === totalPages ||
                        (page >= currentPage - 1 && page <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={page}
                            className={`page-number ${currentPage === page ? 'active' : ''}`}
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        );
                      } else if (page === currentPage - 2 || page === currentPage + 2) {
                        return <span key={page} className="page-ellipsis">...</span>;
                      }
                      return null;
                    })}
                  </div>

                  <button
                    className="pagination-btn"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          )}
        </>
      )}

      {/* Role Change Modal */}
      {roleChangeModalOpen && selectedEmployee && (
        <div className="modal-overlay" onClick={handleCloseRoleChangeModal}>
          <div className="role-change-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Change Role</h3>
              <button className="modal-close-btn" onClick={handleCloseRoleChangeModal}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="employee-info">
                <p><strong>Employee:</strong> {selectedEmployee.FullName}</p>
                <p><strong>Email:</strong> {selectedEmployee.Email}</p>
                <p><strong>Department:</strong> {selectedEmployee.DepartmentName}</p>
                <p><strong>Current Role:</strong> {selectedEmployee.Role || 'Not Assigned'}</p>
              </div>

              <div className="role-selection">
                <label>Select New Role:</label>
                {loadingRoles ? (
                  <div className="loading-roles">Loading available roles...</div>
                ) : (
                  <>
                    <input
                      type="text"
                      placeholder="Search roles..."
                      value={roleSearchTerm}
                      onChange={(e) => setRoleSearchTerm(e.target.value)}
                      className="role-search-input"
                    />
                    <div className="roles-list">
                      {availableRolesForDept
                        .filter(role => role.RoleName.toLowerCase().includes(roleSearchTerm.toLowerCase()))
                        .map(role => (
                          <div
                            key={role.RoleID}
                            className={`role-option ${selectedNewRole === role.RoleName ? 'selected' : ''} ${role.RoleName === selectedEmployee.Role ? 'current' : ''}`}
                            onClick={() => setSelectedNewRole(role.RoleName)}
                          >
                            <div className="role-name">
                              {role.RoleName}
                              {role.RoleName === selectedEmployee.Role && <span className="current-badge">Current</span>}
                            </div>
                            {role.RoleFamilyName && role.RoleFamilyName !== 'No Role Family' && (
                              <div className="role-family">{role.RoleFamilyName}</div>
                            )}
                          </div>
                        ))}
                      {availableRolesForDept.filter(role => role.RoleName.toLowerCase().includes(roleSearchTerm.toLowerCase())).length === 0 && (
                        <div className="no-roles">No roles found for this department</div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={handleCloseRoleChangeModal} disabled={updatingRole}>
                Cancel
              </button>
              <button
                className="btn-save"
                onClick={handleUpdateRole}
                disabled={updatingRole || !selectedNewRole || selectedNewRole === selectedEmployee.Role}
              >
                {updatingRole ? 'Updating...' : 'Update Role'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Snackbar */}
      {snackbar.isOpen && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          duration={snackbar.duration || 4000}
          onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
        />
      )}
      
      {/* Notify Modal */}
      {notifyModalOpen && (
        <div className="modal-overlay" onClick={handleCloseNotifyModal}>
          <div className="notify-modal" onClick={(e) => e.stopPropagation()}>
            <div className="notify-modal-header">
              <div className="notify-header-content">
                <div className="notify-icon">📧</div>
                <div>
                  <h2>Send Assessment Reminders</h2>
                  <p>Notify employees who haven't submitted their self-assessment</p>
                </div>
              </div>
              <button className="notify-close-btn" onClick={handleCloseNotifyModal}>×</button>
            </div>
            
            <div className="notify-modal-body">
              {notSubmittedEmployees.length === 0 ? (
                <div className="notify-success-state">
                  <div className="success-icon">✅</div>
                  <h3>All Caught Up!</h3>
                  <p>All employees have submitted their self-assessments. No reminders needed!</p>
                </div>
              ) : (
                <>
                  <div className="notify-stats">
                    <div className="stat-card">
                      <span className="stat-number">{notSubmittedEmployees.length}</span>
                      <span className="stat-label">Pending Submissions</span>
                    </div>
                    <div className="stat-card">
                      <span className="stat-number">{selectedEmployeesForNotify.length}</span>
                      <span className="stat-label">Selected</span>
                    </div>
                  </div>
                  
                  <div className="notify-select-all">
                    <label className="notify-checkbox-label">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAllToggle}
                        className="notify-checkbox"
                      />
                      <span className="checkmark"></span>
                      <span className="select-all-text">Select All Employees</span>
                    </label>
                  </div>
                  
                  <div className="notify-employees-grid">
                    {notSubmittedEmployees.map((employee) => (
                      <div key={employee.Email} className={`notify-employee-card ${selectedEmployeesForNotify.includes(employee.Email) ? 'selected' : ''}`}>
                        <label className="notify-checkbox-label">
                          <input
                            type="checkbox"
                            checked={selectedEmployeesForNotify.includes(employee.Email)}
                            onChange={() => handleEmployeeSelectToggle(employee.Email)}
                            className="notify-checkbox"
                          />
                          <span className="checkmark"></span>
                          <div className="employee-details">
                            <div className="employee-name">{employee.FullName}</div>
                            <div className="employee-email">{employee.Email}</div>
                            <div className="employee-dept">{employee.DepartmentName} • {employee.Role}</div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>

            <div className="notify-modal-footer">
              <button className="notify-btn-cancel" onClick={handleCloseNotifyModal} disabled={sendingNotifications}>
                Cancel
              </button>
              {notSubmittedEmployees.length > 0 && (
                <button
                  className="notify-btn-send"
                  onClick={sendNotificationEmails}
                  disabled={sendingNotifications || selectedEmployeesForNotify.length === 0}
                >
                  {sendingNotifications ? (
                    <>
                      <span className="spinner"></span>
                      Sending...
                    </>
                  ) : (
                    `Send Reminders (${selectedEmployeesForNotify.length})`
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Bulk Upload Result Popup */}
      <BulkUploadResultPopup
        open={showBulkUploadResult}
        onClose={() => setShowBulkUploadResult(false)}
        data={bulkUploadResult}
        type="roles"
      />
    </div>
  );
}

export default Employees;
